<cf-frontend-sdk-cplace-control-skeleton
  [componentId]="componentId"
  [label]="label"
  [labelPosition]="labelPosition"
  [labelFor]="nativeFormComponentId"
  [validationMessage]="validationMessage"
  [validationSeverity]="validationSeverity"
  [alert]="alert"
  [required]="required"
  [editMode]="($editMode | async)!"
  [submitting]="submitting"
  [submitSuccess]="($submitSuccess | async)!"
  [submitDisabled]="($submitDisabled | async)!"
  [readonly]="readonly"
  [disabled]="disabled"
  (cancelButtonClick)="onCancel()"
>
  <div class="control-wrapper">
    <div class="input-wrapper" [class.cf-frontend-sdk-empty-value]="($showEmptyValue | async)!">
      <input
        #controlInput
        pInputText
        [disabled]="disabled"
        [readOnly]="true"
        [required]="required"
        [placeholder]="value ? '' : ('cf-frontend-sdk.cplace-single-reference-control.placeholder' | translate)"
        [attr.aria-placeholder]="value ? '' : ('cf-frontend-sdk.cplace-single-reference-control.placeholder' | translate)"
        [attr.aria-required]="required"
        [attr.aria-disabled]="disabled"
        [attr.aria-invalid]="validationSeverity !== 'info'"
        (click)="showAutocomplete()"
        (keydown)="handleControlInputKeyDown($event)"
      />
      <p-chip *ngIf="value" [removable]="!(readonly || disabled)" (onRemove)="handleOnRemove()">
        <i *ngIf="value.icon" [class]="value.icon"></i>
        <a [href]="value.url" tabindex="-1">{{ value.label }}</a>
      </p-chip>
    </div>
    <div [class.hide]="!autocompleteVisible" class="autocomplete-wrapper">
      <i
        class="pi pi-search"
        role="button"
        [attr.aria-label]="'cf-frontend-sdk.cplace-single-reference-control.advancedSearch' | translate"
        (click)="openAdvancedSearch()"
      ></i>
      <p-autoComplete
        #autocomplete
        [suggestions]="filteredAutocompleteHits"
        [placeholder]="'cf-frontend-sdk.cplace-single-reference-control.autocompleteInputPlaceholder' | translate"
        [inputId]="nativeFormComponentId"
        (completeMethod)="filterAutocompleteHits($event)"
        (onSelect)="handleSelectAutocompleteHit($event)"
        (onFocus)="triggerAutocompleteMenu()"
        (onBlur)="handleBlurAutocompleteMenu()"
        (onKeyUp)="handleAutocompleteInputKeyUp()"
      >
        <ng-template pTemplate="header">
          <div class="autocomplete-header-wrapper">
            <span class="autocomplete-results-text">{{ autocompleteResultsText }}</span>
            <!-- TODO: Button should be shown according to the AutoCompleteResponse. Label should be dynamic. -->
            <button
              pButton
              [label]="'cf-frontend-sdk.cplace-single-reference-control.createNewText' | translate"
              [attr.aria-label]="'cf-frontend-sdk.cplace-single-reference-control.createNewText' | translate"
              class="p-button-link"
              (click)="createNew()"
            ></button>
          </div>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <div class="autocomplete-item">
            <i *ngIf="item.icon" [class]="item.icon"></i>
            <div class="autocomplete-item-text">
              <span>{{ item.label }}</span>
              <span>{{ item.disambiguation }}</span>
            </div>
          </div>
        </ng-template>
      </p-autoComplete>
    </div>
  </div>
</cf-frontend-sdk-cplace-control-skeleton>
